import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {CarrierTruck} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';
import {useServiceAccount} from '@/composables/useServiceAccount/useServiceAccount';

export const getDeliveriesMenu = (): MenuItemConfig => {
  return {
    type: 'parent',
    label: 'deliveries.deliveries',
    icon: markRaw(CarrierTruck),
    beforeEnter: [
      () => {
        const {isFulfilmentActive} = useServiceAccount();

        if (!isFulfilmentActive.value) {
          return {name: 'dashboard'};
        }

        return true;
      },
    ],
    children: [
      {
        type: 'internal',
        multiplyLabel: true,
        to: {
          name: 'deliveries',
        },
        label: 'overview',
      },
      {
        type: 'internal',
        multiplyLabel: true,
        to: {
          name: 'deliveries-create',
        },
        label: 'deliveries.newDelivery',
      },
    ],
  };
};
